import { ComponentProps, FC } from 'react';

import BaseSvg from '@/designSystem/Icon/Internal/BaseSvg';

export const IconTextH1: FC<ComponentProps<typeof BaseSvg>> = ({
  className = '',
}) => (
  <BaseSvg className={className}>
    <path d="M0 20V0H3.0333V8.4668H10.7923V0H13.8338V20H10.7923V11.5039H3.0333V20H0Z" />
    <path d="M20 8V20H18.18V10.1152H18.1212L15.7714 11.9082V9.91602L18.2683 8H20Z" />
  </BaseSvg>
);
